import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentRo = () => {
    return (
        <HighlightedText
            text="Obțineți bonusul dumneavoastră 325% Bonus + 400 ROTIRI GRATUITE"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['bonusul', 'dumneavoastră', '400']}
            className={styles.text_content}
        />
    )
}
